// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HyjWTKT13v3GYLg_btgm {
  width: 20px;
  height: 15px;
}`, "",{"version":3,"sources":["webpack://./tcbase/static/js2/modules/samples/components/geolocationmenuitem/geolocation-menu-item.module.scss"],"names":[],"mappings":"AACA;EACE,WAAA;EACA,YAAA;AAAF","sourcesContent":["@import \"/tcbase/static/style/settings/settings.rl.variables.scss\"; @import \"/tcbase/static/style/settings/settings.bs.variables.scss\";\n.flag_icon {\n  width: 20px;\n  height: 15px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flag_icon": `HyjWTKT13v3GYLg_btgm`
};
export default ___CSS_LOADER_EXPORT___;
